module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigil_not_in_toc2",
    attrs: {
      "id": "id00134"
    }
  }, [_vm._v("CHAPTER III")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc1",
    attrs: {
      "id": "id00135"
    }
  }, [_vm._v("THE SHOP-BOY")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00136"
    }
  }, [_vm._v("When Pratt arrived at Eldrick & Pascoe's office at his usual hour of nine next morning, he found the senior partner already there. And with him was a young man whom the clerk at once set down as Mr. Bartle Collingwood, and looked at with considerable interest and curiosity. He had often heard of Mr. Bartle Collingwood, but had never seen him. He knew that he was the only son of old Antony Bartle's only child—a daughter who had married a London man; he knew, too, that Collingwood's parents were both dead, and that the old bookseller had left their son everything he possessed—a very nice little fortune, as Eldrick had observed last night. And since last night he had known that Collingwood had just been called to the Bar, and was on the threshold of what Eldrick, who evidently knew all about it, believed to be a promising career. Well, there he was in the flesh; and Pratt, who was a born observer of men and events, took a good look at him as he stood just within the private room, talking to Eldrick.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00137"
    }
  }, [_vm._v("A good-looking fellow; what most folk would call handsome; dark, clean-shaven, tall, with a certain air of reserve about his well-cut features, firm lips, and steady eyes that suggested strength and determination. He would look very well in wig and gown, decided Pratt, viewing matters from a professional standpoint; he was just the sort that clients would feel a natural confidence in, and that juries would listen to. Another of the lucky ones, too; for Pratt knew the contents of Antony Bartle's will, and that the young man at whom he was looking had succeeded to a cool five-and-twenty thousand pounds, at least, through his grandfather's death.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00138"
    }
  }, [_vm._v("\"Here is Pratt,\" said Eldrick, glancing into the outer office as the clerk entered it. \"Pratt, come in here—here is Mr. Bartle Collingwood, He would like you to tell him the facts about Mr. Bartle's death.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00139"
    }
  }, [_vm._v("Pratt walked in—armed and prepared. He was a clever hand at foreseeing things, and he had known all along that he would have to answer questions about the event of the previous night.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00140"
    }
  }, [_vm._v("\"There's very little to tell, sir,\" he said, with a polite acknowledgment of Collingwood's greeting. \"Mr. Bartle came up here just as I was leaving—everybody else had left. He wanted to see Mr. Eldrick. Why, he didn't say. He was coughing a good deal when he came in, and he complained of the fog outside, and of the stairs. He said something—just a mere mention—about his heart being bad. I lighted the gas in here, and helped him into the chair. He just sat down, laid his head back, and died.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00141"
    }
  }, [_vm._v("\"Without saying anything further?\" asked Collingwood.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00142"
    }
  }, [_vm._v("\"Not a word more, Mr. Collingwood,\" answered Pratt. \"He—well, it was just as if he had dropped off to sleep. Of course, at first I thought he'd fainted, but I soon saw what it was—it so happens that I've seen a death just as sudden as that, once before—my landlady's husband died in a very similar fashion, in my presence. There was nothing I could do, Mr. Collingwood—except ring up Mr. Eldrick, and the doctor, and the police.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00143"
    }
  }, [_vm._v("\"Mr. Pratt made himself very useful last night in making arrangements,\" remarked Eldrick, looking at Collingwood. \"As it is, there is very little to do. There will be no need for any inquest; Melrose has given his certificate. So—there are only the funeral arrangements. We can help you with that matter, of course. But first you'd no doubt like to go to your grandfather's place and look through his papers? We have his will here, you know—and I've already told you its effect.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00144"
    }
  }, [_vm._v("\"I'm much obliged to you, Mr. Pratt,\" said Collingwood, turning to the clerk. He turned again to Eldrick. \"All right,\" he went on. \"I'll go over to Quagg Alley. Bye-the-bye, Mr. Pratt—my grandfather didn't tell you anything of the reason of his call here?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00145"
    }
  }, [_vm._v("\"Not a word, sir,\" replied Pratt. \"Merely said he wanted Mr. Eldrick.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00146"
    }
  }, [_vm._v("\"Had he any legal business in process?\" asked Collingwood.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00147"
    }
  }, [_vm._v("Eldrick and his clerk both shook their heads. No, Mr. Bartle had no business of that sort that they knew of. Nothing—but there again Pratt was prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00148"
    }
  }, [_vm._v("\"It might have been about the lease of that property in Horsebridge Land, sir,\" he said, glancing at his principal. \"He did mention that, you know, when he was in here a few weeks ago.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00149"
    }
  }, [_vm._v("\"Just so,\" agreed Eldrick. \"Well, you'll let me know if we can be of use,\" he went on, as Collingwood turned away. \"Pratt can be at your disposal, any time.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00150"
    }
  }, [_vm._v("Collingwood thanked him and went off. He had travelled down from London by the earliest morning train, and leaving his portmanteau at the hotel of the Barford terminus, had gone straight to Eldrick & Pascoe's office; accordingly this was his first visit to the shop in Quagg Alley. But he knew the shop and its surroundings well enough, though he had not been in Barford for some time; he also knew Antony Bartle's old housekeeper, Mrs. Clough, a rough and ready Yorkshirewoman, who had looked after the old man as long as he, Collingwood, could remember. She received him as calmly as if he had merely stepped across the street to inquire after his grandfather's health.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00151"
    }
  }, [_vm._v("\"I thowt ye'd be down here first thing, Mestur Collingwood,\" she said, as he walked into the parlor at the back of the shop. \"Of course, there's naught to be done except to see after yer grandfather's burying. I don't know if ye were surprised or no when t' lawyers tellygraphed to yer last night? I weren't surprised to hear what had happened. I'd been expecting summat o' that sort this last month or two.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00152"
    }
  }, [_vm._v("\"You mean—he was failing?\" asked Collingwood.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00153"
    }
  }, [_vm._v("\"He were gettin' feebler and feebler every day,\" said the housekeeper. \"But nobody dare say so to him, and he wouldn't admit it his-self. He were that theer high-spirited 'at he did things same as if he were a young man. But I knew how it 'ud be in the end—and so it has been—I knew he'd go off all of a sudden. And of course I had all in readiness—when they brought him back last night there was naught to do but lay him out. Me and Mrs. Thompson next door, did it, i' no time. Wheer will you be for buryin' him, Mestur Collingwood?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00154"
    }
  }, [_vm._v("\"We must think that over,\" answered Collingwood.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00155"
    }
  }, [_vm._v("\"Well, an' theer's all ready for that, too,\" responded Mrs. Clough. \"He's had his grave all ready i' the cemetery this three year—I remember when he bowt it—it's under a yew-tree, and he told me 'at he'd ordered his monnyment an' all. So yer an' t' lawyers'll have no great trouble about them matters. Mestur Eldrick, he gev' orders for t' coffin last night.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00156"
    }
  }, [_vm._v("Collingwood left these gruesome details—highly pleasing to their narrator—and went up to look at his dead grandfather. He had never seen much of him, but they had kept up a regular correspondence, and always been on terms of affection, and he was sorry that he had not been with the old man at the last. He remained looking at the queer, quiet, old face for a while; when he went down again, Mrs. Clough was talking to a sharp-looking lad, of apparently sixteen or seventeen years, who stood at the door leading into the shop, and who glanced at Collingwood with keen interest and speculation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00157"
    }
  }, [_vm._v("\"Here's Jabey Naylor wants to know if he's to do aught, Mestur,\" said the housekeeper. \"Of course, I've telled him 'at we can't have the shop open till the burying's over—so I don't know what theer is that he can do.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00158"
    }
  }, [_vm._v("\"Oh, well, let him come into the shop with me,\" answered Collingwood. He motioned the lad to follow him out of the parlour. \"So you were Mr. Bartle's assistant, eh?\" he asked. \"Had he anybody else?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00159"
    }
  }, [_vm._v("\"Nobody but me, sir,\" replied the lad. \"I've been with him a year.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00160"
    }
  }, [_vm._v("\"And your name's what?\" inquired Collingwood.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00161"
    }
  }, [_vm._v("\"Jabez Naylor, sir, but everybody call me Jabey.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00162"
    }
  }, [_vm._v("\"I see—Jabey for short, eh?\" said Collingwood good-humouredly. He walked into the shop, followed by the boy, and closed the door. The outer door into Quagg Alley was locked: a light blind was drawn over the one window; the books and engravings on the shelves and in the presses were veiled in a half-gloom. \"Well, as Mrs. Clough says, we can't do any business for a few days, Jabey—after that we must see what can be done. You shall have your wages just the same, of course, and you may look in every day to see if there's anything you can do. You were here yesterday, of course? Were you in the shop when Mr. Bartle went out?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00163"
    }
  }, [_vm._v("\"Yes, sir,\" replied the lad. \"I'd been in with him all the afternoon. I was here when he went out—and here when they came to say he'd died at Mr. Eldrick's.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00164"
    }
  }, [_vm._v("Collingwood sat down in his grandfather's chair, at a big table, piled high with books and papers, which stood in the middle of the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00165"
    }
  }, [_vm._v("\"Did my grandfather seem at all unwell when he went out?\" he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00166"
    }
  }, [_vm._v("\"No, sir. He had been coughing a bit more than usual—that was all. There was a fog came on about five o'clock, and he said it bothered him.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00167"
    }
  }, [_vm._v("\"What had he been doing during the afternoon? Anything particular?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00168"
    }
  }, [_vm._v("\"Nothing at all particular before half-past four or so, sir.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00169"
    }
  }, [_vm._v("Collingwood took a closer look at Jabez Naylor. He saw that he was an observant lad, evidently of superior intelligence—a good specimen of the sharp town lad, well trained in a modern elementary school.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00170"
    }
  }, [_vm._v("\"Oh?\" he said. \"Nothing particular before half-past four, eh? Did he do something particular after half-past four?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00171"
    }
  }, [_vm._v("\"There was a post came in just about then, sir,\" answered Jabey. \"There was an American letter—that's it, sir—just in front of you. Mr. Bartle read it, and asked me if we'd got a good clear copy of Hopkinson's "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("History of Barford")]), _vm._v(". I reminded him that there was a copy amongst the books that had been bought from Mallathorpe's Mill some time ago.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00172"
    }
  }, [_vm._v("\"Books that had belonged to Mr. John Mallathorpe, who was killed?\" asked"), _c('br', {
    staticClass: "calibre5"
  }), _c('span', {
    staticClass: "filler"
  }), _vm._v("Collingwood, who was fully acquainted with the chimney accident."), _c('br', {
    staticClass: "calibre5"
  }), _c('span', {
    staticClass: "filler"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00173"
    }
  }, [_vm._v("\"Yes, sir, Mr. Bartle bought a lot of books that Mr. Mallathorpe had at the Mill—local books. They're there in that corner: they were put there when I fetched them, and he'd never looked over them since, particularly.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00174"
    }
  }, [_vm._v("\"Well—and this "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("History of Barford")]), _vm._v("? You reminded him of it?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00175"
    }
  }, [_vm._v("\"I got it out for him, sir. He sat down—where you're sitting—and began to examine it. He said something about it being a nice copy, and he'd get it off that night—that's it, sir: I didn't read it, of course. And then he took some papers out of a pocket that's inside it, and I heard him say 'Bless my soul—who'd have thought it!'\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00176"
    }
  }, [_vm._v("Collingwood picked up the book which the boy indicated—a thick, substantially bound volume, inside one cover of which was a linen pocket, wherein were some loose maps and plans of Barford.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00177"
    }
  }, [_vm._v("\"These what he took out?\" he asked, holding them up.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00178"
    }
  }, [_vm._v("\"Yes, sir, but there was another paper, with writing on it—a biggish sheet of paper—written all over.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00179"
    }
  }, [_vm._v("\"Did you see what the writing was? Did you see any of it?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00180"
    }
  }, [_vm._v("\"No, sir—only that it was writing, I was dusting those shelves out, over there; when I heard Mr. Bartle say what he did. I just looked round, over my shoulder—that was all.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00181"
    }
  }, [_vm._v("\"Was he reading this paper that you speak of?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00182"
    }
  }, [_vm._v("\"Yes, sir—he was holding it up to the gas, reading it.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00183"
    }
  }, [_vm._v("\"Do you know what he did with it?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00184"
    }
  }, [_vm._v("\"Yes, sir—he folded it up and put it in his pocket.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00185"
    }
  }, [_vm._v("\"Did he say any more—make any remark?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00186"
    }
  }, [_vm._v("\"No, sir. He wrote a letter then.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00187"
    }
  }, [_vm._v("\"At once?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00188"
    }
  }, [_vm._v("\"Yes, sir—straight off. But he wasn't more than a minute writing it."), _c('br', {
    staticClass: "calibre5"
  }), _c('span', {
    staticClass: "filler"
  }), _vm._v("Then he sent me to post it at the pillar-box, at the end of the Alley.\""), _c('br', {
    staticClass: "calibre5"
  }), _c('span', {
    staticClass: "filler"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00189"
    }
  }, [_vm._v("\"Did you read the address?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00190"
    }
  }, [_vm._v("The lad turned to a book which stood with others in a rack over the chimney-piece, and tapped it with his finger.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00191"
    }
  }, [_vm._v("\"Yes, sir—because Mr. Bartle gave orders when I first came here that a register of every letter sent out was to be kept—I've always entered them in this book.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00192"
    }
  }, [_vm._v("\"And this letter you're talking about—to whom was it addressed?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00193"
    }
  }, [_vm._v("\"Miss Mallathorpe, Normandale Grange, sir.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00194"
    }
  }, [_vm._v("\"You went and posted it at once?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00195"
    }
  }, [_vm._v("\"That very minute, sir.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00196"
    }
  }, [_vm._v("\"Was it soon afterwards that Mr. Bartle went out?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00197"
    }
  }, [_vm._v("\"He went out as soon as I came back, sir.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00198"
    }
  }, [_vm._v("\"And you never saw him again?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00199"
    }
  }, [_vm._v("Jabey shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00200"
    }
  }, [_vm._v("\"Not alive, sir,\" he answered. \"I saw him when they brought him back.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00201"
    }
  }, [_vm._v("\"How long had he been out when you heard he was dead?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00202"
    }
  }, [_vm._v("\"About an hour, sir—just after six it was when they told Mrs. Clough and me. He went out at ten minutes past five.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00203"
    }
  }, [_vm._v("Collingwood got up. He gave the lad's shoulder a friendly squeeze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00204"
    }
  }, [_vm._v("\"All right!\" he said. \"Now you seem a smart, intelligent lad—don't mention a word to any one of what we've been talking about. You have not mentioned it before, I suppose? Not a word? That's right—don't. Come in again tomorrow morning to see if I want you to be here as usual. I'm going to put a manager into this shop.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00205"
    }
  }, [_vm._v("When the boy had gone Collingwood locked up the shop from the house side, put the key in his pocket, and went into the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00206"
    }
  }, [_vm._v("\"Mrs. Clough,\" he said. \"I want to see the clothes which my grandfather was wearing when he was brought home last night. Where are they?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00207"
    }
  }, [_vm._v("\"They're in that little room aside of his bed-chamber, Mestur Collingwood,\" replied the housekeeper. \"I laid 'em all there, on the clothes-press, just as they were taken off of him, by Lawyer Eldrick's orders—he said they hadn't been examined, and wasn't to be, till you came. Nobody whatever's touched 'em since.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00208"
    }
  }, [_vm._v("Collingwood went upstairs and into the little room—a sort of box-room opening out of that in which the old man lay. There were the clothes; he went through the pockets of every garment. He found such things as keys, a purse, loose money, a memorandum book, a bookseller's catalogue or two, two or three letters of a business sort—but there was no big folded paper, covered with writing, such as Jabey Naylor had described.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00209"
    }
  }, [_vm._v("The mention of that paper had excited Collingwood's curiosity. He rapidly summed up what he had learned. His grandfather had found a paper, closely written upon, in a book which had been the property of John Mallathorpe, deceased. The discovery had surprised him, for he had given voice to an exclamation of what was evidently astonishment. He had put the paper in his pocket. Then he had written a letter—to Mrs. Mallathorpe of Normandale Grange. When his shop-boy had posted that letter, he himself had gone out—to his solicitor. What, asked Collingwood, was the reasonable presumption? The old man had gone to Eldrick to show him the paper which he had found.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00210"
    }
  }, [_vm._v("He lingered in the little room for a few minutes, thinking. No one but Pratt had been with Antony Bartle at the time of his seizure and sudden death. What sort of a fellow was Pratt? Was he honest? Was his word to be trusted? Had he told the precise truth about the old man's death? He was evidently a suave, polite, obliging sort of fellow, this clerk, but it was a curious thing that if Antony Bartle had that paper, whatever it was—in his pocket when he went to Eldrick's office it should not be in his pocket still—if his clothing had really remained untouched. Already suspicion was in Collingwood's mind—vague and indefinable, but there.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00211"
    }
  }, [_vm._v("He was half inclined to go straight back to Eldrick & Pascoe's and tell Eldrick what Jabey Naylor had just told him. But he reflected that while Naylor went out to post the letter, the old bookseller might have put the paper elsewhere; locked it up in his safe, perhaps. One thing, however, he, Collingwood, could do at once—he could ask Mrs. Mallathorpe if the letter referred to the paper. He was fully acquainted with all the facts of the Mallathorpe history; old Bartle, knowing they would interest his grandson, had sent him the local newspaper accounts of its various episodes. It was only twelve miles to Normandale Grange—a motor-car would carry him there within the hour. He glanced at his watch—just ten o 'clock.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "id00212"
    }
  }, [_vm._v("An hour later, Collingwood found himself standing in a fine oak-panelled room, the windows of which looked out on a romantic valley whose thickly wooded sides were still bright with the red and yellow tints of autumn. A door opened—he turned, expecting to see Mrs. Mallathorpe. Instead, he found himself looking at a girl, who glanced inquiringly at him, and from him to the card which he had sent in on his arrival.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5fa2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/content_0004.vue
// module id = 69
// module chunks = 0